import React, { useMemo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";

import ClientButton from "../ClientButton";
import { authenticateClient, } from '../../store/actions/access'
import { getStateValue } from "../../store/selectors";

import userIcon from "../../images/icons8-user-96.png";
import bellIcon from "../../images/icons8-bell-96.png";
import calendarIcon from "../../images/icons8-calendar-100.png";
import translations from "../../utils/translations"
import getUrlParams from '../../utils/getUrlParams'

const pagesToShowHeader2 = ["/client/products", "/client/stalls"]

const ClientTopBar = (props) => {
  const { 
    header={},

    authenticateClient,

    currentTranslations, 
    attentionType, 
    sysCompanyId, 
    foodStallId,
    unReadClientNotifications,
  } = props;

  const {
    headerTitle,
    HeaderRight,
    contStyle={},
    headerStyle={}
  } = header
  
  const [fallbackTimeout, setFallbackTimeout] = useState(null)
  const isAndroid = navigator.userAgent?.includes("Android");

  useEffect(()=>{
    if (["/client/stalls", "/client/products"].includes(props.location?.pathname) && (!sysCompanyId && !foodStallId)) {
      setFallbackTimeout(setTimeout(()=>{
        props.history.push("/client/company_qr_scanning");
      }, [2000]))
    }
  }, [])
  
  useEffect(() => {
    if (fallbackTimeout && (sysCompanyId || foodStallId)) {
      clearTimeout(fallbackTimeout);
    }
  }, [fallbackTimeout, sysCompanyId, foodStallId,]);

  const goBackHandler = () => {
    if(props.location.pathname?.includes('/client/products')){
      if(attentionType == 'food_center'){
        const params = getUrlParams(document.URL);
        if(params?.companyCode){
          props.history.push(`/client/stalls?companyCode=${params?.companyCode}`)
        } else if (params?.tableCode) {
          props.history.push(`/client/stalls?tableCode=${params?.tableCode}`)
        } else {
          props.history.push(`/client/stalls`)
        }
      }
      else {
        props.history.push('/client/company_qr_scanning')
      }
    }
    else if(props.location.pathname?.includes('/client/stalls')){
      props.history.push('/client/company_qr_scanning')
    }
    else{
      props.history.goBack()
    }
  }

  return pagesToShowHeader2?.includes(props.location.pathname) ? (
    // This is render when the client is not in a main screen
    <div style={styles?.barContainer}>
      {/* Left arrow */}
      <ClientButton onClick={goBackHandler}>
        <Icon name={isAndroid ? "arrow left" : "chevron left"} />
      </ClientButton>

      {/* Right side buttons */}
      <div style={styles?.rightSide}>
        {/* Calendar icon */}
        <ClientButton onClick={()=>authenticateClient(()=>props.history.push('/client/reservations'))}>
          <img src={calendarIcon} style={{ width: "30px", height: "30px" }} />
        </ClientButton>
        {/* Bell icon */}
        <ClientButton style={{ position: 'relative' }} onClick={()=>authenticateClient(()=>props.history.push('/client/notifications'))}>
          <img src={bellIcon} style={{ width: "30px", height: "30px" }} />

          {/* Unread notifications badge */}
          {/* {unReadClientNotifications?.length > 0 && (
            <div style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              backgroundColor: 'red',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px'
            }}>
              {unReadClientNotifications.length}
            </div>
          )} */}
        </ClientButton>
        {/* User icon */}
        <ClientButton onClick={()=>props.history.push('/client/account')}>
          <img src={userIcon} style={{ width: "30px", height: "30px" }} />
        </ClientButton>
      </div>
    </div>
  ) : typeof headerTitle == 'string' ? (
    <div style={{...styles?.barContainer, ...contStyle}}>
      {/* Left arrow */}
      <ClientButton onClick={goBackHandler}  style={{ position: "absolute", alignSelf: 'center', zIndex: 10,}}>
        <Icon name={isAndroid ? "arrow left" : "chevron left"} />
      </ClientButton>

      {/* Title */}
      <div style={{...styles?.rightTitle, ...headerStyle}}>
        {headerTitle}
      </div>

      {HeaderRight && (
        <div style={{position: "absolute", right: '15px'}}>
          <HeaderRight />
        </div>
      )}
    </div>
  ) : (
    <div style={styles?.barContainer}>
      {/* User icon */}
      <ClientButton onClick={()=>props.history.push('/client/account')}>
        <img src={userIcon} style={{ width: "30px", height: "30px" }} />
      </ClientButton>

      {/* Right side buttons */}
      <div style={styles?.rightSide}>
        {/* Calendar icon */}
        <ClientButton onClick={()=>authenticateClient(()=>props.history.push('/client/reservations'))}>
          <img src={calendarIcon} style={{ width: "30px", height: "30px" }} />
        </ClientButton>

        {/* Bell icon */}
        <ClientButton style={{ position: 'relative' }} onClick={()=>authenticateClient(()=>props.history.push('/client/notifications'))}>
          <img src={bellIcon} style={{ width: "30px", height: "30px", position: 'relative', }} />

          {/* Unread notifications badge */}
          {/* {unReadClientNotifications?.length > 0 && (
            <div style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              backgroundColor: 'red',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px'
            }}>
              {unReadClientNotifications.length}
            </div>
          )} */}
        </ClientButton>
      </div>
    </div>
  );
};

const styles = {
  barContainer: {
    display: "flex",
    height: "8vh",
    flexDirection: "row",
    backgroundColor: "white",
    alignItems: "center",
    padding: "0px 15px",
    position: "sticky",
    zIndex: 101,
    width: "100%",
    top: "0px",
    "box-shadow": "rgba(0, 0, 0, 0.08) 0px 0.5px 10px"
  },
  rightSide: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  rightTitle: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    fontSize: '16px',
    'font-weight': '500',
  },
  topButton: {
    fontSize: "20px",
    cursor: "pointer",
    borderRadius: "15px",
    transition: "opacity 0.2s ease",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const mapDispatchToProps = (dispatch) => ({
  authenticateClient: (functionParam) => dispatch(authenticateClient(functionParam))
});

const mapStateToProps = (state) => ({
  currentTranslations: translations[state.app.lang],
  attentionType: state.access.attentionType,
  sysCompanyId: state.access.sysCompanyId,
  foodStallId: state.access.foodStallId,
  unReadClientNotifications: getStateValue(state.client_notifications.entities)?.filter((n) => !n?.read),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientTopBar);
